const SHORT_ID_LENGTH = 6;

export const shortenId = (id: string): string => `${id.slice(0, SHORT_ID_LENGTH)}…`;
